import React from 'react';

export const SvgHelp = (props) => (
  <svg
    overflow='hidden'
    viewBox='0 0 655 655'
    xmlns='http://www.w3.org/2000/svg'
    width='100%'
    height='100%'
    {...props}
  >
    <defs>
      <clipPath id='Help_svg__a'>
        <path d='M341 1305h1088v1329H341z' />
      </clipPath>
    </defs>
    <g
      transform='translate(-558.56 -1529.2) scale(1.0006)'
      clipPath='url(#Help_svg__a)'
    >
      <path
        d='M560.5 1638.8c0-59.83 48.503-108.33 108.34-108.33h433.32c59.83 0 108.34 48.5 108.34 108.33v433.34c0 59.83-48.51 108.33-108.34 108.33H668.84c-59.832 0-108.34-48.5-108.34-108.33z'
        fillRule='evenodd'
        stroke='#00b0f0'
        strokeMiterlimit={8}
        strokeWidth={4.583}
      />
      <path
        d='M748.807 1766.35q0-29.363 18.854-59.344 18.854-30.29 55.017-50.071t84.379-19.781q44.817 0 79.125 16.69 34.308 16.381 52.853 44.817 18.854 28.436 18.854 61.816 0 26.272-10.818 46.053-10.509 19.781-25.345 34.308-14.527 14.218-52.544 48.217-10.509 9.582-17 17-6.182 7.109-9.272 13.291-3.091 5.873-4.946 12.054-1.545 5.873-4.945 21.018-5.873 32.145-36.781 32.145-16.072 0-27.2-10.509-10.817-10.509-10.817-31.217 0-25.963 8.036-44.817 8.036-19.163 21.327-33.381 13.291-14.527 35.854-34.308 19.781-17.309 28.436-25.963 8.963-8.963 14.836-19.781 6.182-10.818 6.182-23.49 0-24.727-18.545-41.726-18.236-17-47.29-17-34 0-50.071 17.309-16.072 17-27.2 50.38-10.508 34.926-39.871 34.926-17.31 0-29.363-12.054-11.745-12.363-11.745-26.581zm150.83 338.75q-18.854 0-33.072-12.054-13.909-12.363-13.909-34.308 0-19.472 13.6-32.763t33.381-13.291q19.472 0 32.763 13.291t13.291 32.763q0 21.636-13.909 33.999t-32.145 12.363z'
        fill='#fff'
        aria-label='?'
      />
    </g>
  </svg>
);
